// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"e150142e","33":"7b0576e7","222":"1f66ca21","507":"41b90d68","524":"0219992d","983":"62028a87"}[chunkId] + ".chunk.js";
};